import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=0261f9b4&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=0261f9b4&prod&lang=css&"
import style1 from "./wallet.vue?vue&type=style&index=1&id=0261f9b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261f9b4",
  null
  
)

export default component.exports